import { createApp as _createApp } from 'vue'
/* eslint-disable import/no-unresolved */
import { Button } from '@honk-ds/vue'

import { config } from '@finn-no/huck-config'
import App from './App.vue'
import { initFluent } from './i18n/index.js'
import { configInjectionKey, fluentInjectionKey, initialPropsInjectionKey } from './injectionKeys.js'
import { renderPrivacyModal } from './gdpr/index.js'

export function createApp(initialProps) {
  const { topLevelDomain } = config

  const app = _createApp(App, initialProps)

  const fluent = initFluent(topLevelDomain)

  app.use(fluent).use(Button)

  app.provide(fluentInjectionKey, fluent.format)
  app.provide(initialPropsInjectionKey, {
    ...initialProps,
    topLevelDomain,
  })
  app.provide(configInjectionKey, config)

  renderPrivacyModal(config)

  return { app }
}
